export const overrides = theme => ({
  label: {
    fontSize: theme.typography.caption.fontSize,
  },
})
